import Vue from 'vue';
import { FCAnalytics } from '@fc/app-common';

Vue.use(FCAnalytics, {
  writeKey: process.env.NUXT_ENV_SEGMENT
});
